import React, { useEffect } from 'react'
import StyledFormStep from '../JoinClubHeader/StyledFormStep.styles';
import StyledVideoWelcome from './VideoWelcome.styles';
import welcomeVideo from '../../assets/wc_thankyou_background.mp4'
const VideoWelcome = () => {

    useEffect(() => {
        
        const vidBG = document.querySelector("#videoBkg");
        let runVideo = () => vidBG.play();
        setTimeout(runVideo, 400)
     
    }, [])
  
  
  return (
    <StyledVideoWelcome>
            

          <div className="hero-section">

      <h3>Welcome to the club!</h3>
      <p>Get ready to discover our award winning wines! You’ll receive an email confirming your subscription shortly.</p>
      <br />
      <div className="hero-welcome-footer">
      <p>Questions about your order?</p>
      <a class="contact-link" href="">Contact Us</a>
      <br />
      <StyledFormStep>

      <button className="btn btn-primary">Back to cooper's hawk</button>
      </StyledFormStep>
      </div>
  

          </div>
         <video id="videoBkg" poster="https://www.sicontis.com/codepen/cpc-spacing/ski.png" autoplay muted loop >
            <source src={welcomeVideo} type="video/mp4" />
          </video>


          


    </StyledVideoWelcome>
  )
}

export default VideoWelcome